// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--Ycdnd","text":"_103a151b99--text--GYh4n","attention":"_103a151b99--attention--uRQ8R","button":"_103a151b99--button--Kh5P8"};